/**
 * 홈 화면 검수 체크리스트 카드 — 작업 진입 시 상시 리마인드.
 *
 * 항목 데이터는 ``./data`` 의 ``REVIEW_CHECKLIST`` 에서 온다.
 */

import { ListChecks } from "lucide-react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

import { REVIEW_CHECKLIST, pickLang } from "./data";

export default function ReviewChecklistCard() {
  const { t, i18n } = useTranslation();
  const lang = i18n.resolvedLanguage;

  return (
    <section className="rounded-lg border border-amber-200 bg-amber-50/60 p-5">
      <div className="mb-3 flex items-center justify-between">
        <h2 className="flex items-center gap-2 text-sm font-semibold text-amber-900">
          <ListChecks className="h-4 w-4 text-amber-600" />
          {t("guide.checklist.title")}
        </h2>
        <Link to="/guide" className="text-xs font-medium text-amber-700 hover:underline">
          {t("guide.checklist.moreLink")}
        </Link>
      </div>
      {/* 번호는 CSS list-marker 로 렌더 — DOM 텍스트로 숫자를 넣지 않아
          통계 카드 값(예: "8")과의 getByText 충돌을 방지한다. */}
      <ol className="grid list-decimal grid-cols-1 gap-x-8 gap-y-1.5 pl-5 text-sm text-amber-950/90 marker:font-semibold marker:text-amber-600 sm:grid-cols-2">
        {REVIEW_CHECKLIST.map((item) => (
          <li key={item.id} className="pl-1">
            {pickLang(item.text, lang)}
          </li>
        ))}
      </ol>
    </section>
  );
}
